import { Component, Host, Prop, h } from '@stencil/core';
import { VARIANTS } from './enums/variants';
import { WEIGHTS } from './enums/weights';

@Component({
  tag: 'mtx-typography',
  styleUrl: 'mtx-typography.css',
  shadow: true,
})
export class MtxTypography {
  @Prop({ reflect: true }) variant: (typeof VARIANTS)[number];
  @Prop({ reflect: true }) weight: (typeof WEIGHTS)[number];
  @Prop({ reflect: true }) underline = false;
  @Prop({ reflect: true }) italic = false;

  private slotRef?: HTMLSlotElement;

  componentDidLoad(): void {
    const styleElement = document.createElement('style');
    styleElement.innerHTML = `a{color:var(--totem-text-color-link)}a:hover{color:var(--totem-text-color-link-hover)}a:focus{color:var(--totem-text-color-link-pressing)}`;

    const slottedElements = this.slotRef?.assignedElements();

    if (slottedElements && slottedElements.length > 0) {
      slottedElements[0].prepend(styleElement);
    }
  }

  render(): JSX.Element {
    return (
      <Host>
        <slot ref={el => (this.slotRef = el as HTMLSlotElement | undefined)}></slot>
      </Host>
    );
  }
}
